import type { ClientAbility } from "../rules";
import { AbilityTimeDescription } from "../rules";

export const Ability = ({ ability }: { ability: ClientAbility }) => <div className="ability">
  <div style={{ borderBottom: "1px solid #646cff" }}>
    <b>
      {ability.oncePerBattle ? "Once Per Battle, " : ""}
      {AbilityTimeDescription[ability.time]}
    </b>
  </div>
  <b>{ability.name}:</b> <i>{ability.description}.</i>
  {ability.declare ? <>
    <br />
    <br />
    <b>Declare: </b>
    {ability.declare}.
  </> : null}
  {ability.usedBy ? <>
    <br />
    <br />
    <b>Used By: </b>
    {ability.usedBy}.
  </> : null}
  <br />
  <br />
  <b>Effect: </b>
  {ability.effect}.
</div>;
